import { FetchResult } from '@apollo/client'
import { client } from '../../../..'
import {
  MANAGER_CLOSE_MEETING,
  SET_ACTIVE_MEETING_STEP,
  UPDATE_MEETING_FEEDBACK,
  UPDATE_MEETING_STEP,
} from '../../../../graphql/meeting/MeetingMutations'
import {
  ManagerCloseMeetingInput,
  ManagerCloseMeetingMutation,
  ManagerCloseMeetingMutationVariables,
  MeetingStep,
  MeetingStepStatus,
  SetNextMeetingStepMutation,
  SetNextMeetingStepMutationVariables,
  UpdateMeetingFeedbackMutation,
  UpdateMeetingFeedbackMutationVariables,
  UpdateMeetingStepMutation,
  UpdateMeetingStepMutationVariables,
} from '../../../../types'
import { GraphQLFormattedError } from 'graphql'

export const setMeetingStep = (meetingId: number, step: MeetingStep, currentStepStatus?: MeetingStepStatus): Promise<FetchResult> => {
  return client.mutate<SetNextMeetingStepMutation, SetNextMeetingStepMutationVariables>({
    mutation: SET_ACTIVE_MEETING_STEP,
    variables: {
      id: meetingId,
      nextStepId: step.id,
      stepType: step.type,
      currentStepStatus,
    },
  })
}

export const updateMeetingStep = (
  meetingStepId: number,
  newStepStatus: MeetingStepStatus,
): Promise<FetchResult<UpdateMeetingStepMutation>> => {
  return client.mutate<UpdateMeetingStepMutation, UpdateMeetingStepMutationVariables>({
    mutation: UPDATE_MEETING_STEP,
    variables: {
      id: meetingStepId,
      newStepStatus: newStepStatus,
    },
  })
}

export const addOrUpdateFeedback = async (meetingId: number, feedback: string): Promise<void> => {
  await client.mutate<UpdateMeetingFeedbackMutation, UpdateMeetingFeedbackMutationVariables>({
    mutation: UPDATE_MEETING_FEEDBACK,
    variables: {
      meetingId,
      feedback,
    },
    update: (_store, { data }) => {
      if (!data || !data.updateMeetingFeedback) {
        throw new Error('Invalid UpdateMeetingFeedback mutation')
      }
    },
  })
}

export const ManagerCloseMeeting = async (
  closeMeetingInput: ManagerCloseMeetingInput,
): Promise<{
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { errors } = await client.mutate<ManagerCloseMeetingMutation, ManagerCloseMeetingMutationVariables>({
    mutation: MANAGER_CLOSE_MEETING,
    variables: {
      meetingInput: closeMeetingInput,
    },
  })

  return { errors }
}
